const widgetImages = document.querySelectorAll('.widget img');

for (const img of widgetImages) {
  img.addEventListener('error', () => window.dataLayer.push({
    event: 'widget-image-error',
    imageUrl: img.src,
  }));
}
